<template>
  <BModal :active.sync="isActive" has-modal-card full-screen :can-cancel="false">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title font-bold">
          {{ item.category }}
          <a class="close-icon" @click="$emit('close')">
            <BIcon icon="close" size="is-medium"> </BIcon>
          </a>
        </p>
      </header>
      <section class="modal-card-body">
        <div class="columns is-mobile is-centered font-medium">
          {{ $t('general.league') }}
        </div>
        <div id="teamModalDetailsModalTable" class="columns is-mobile is-centered font-bold is-gapless">
          <div class="column is-3">{{ $t('general.average') }}(AVG)</div>
          <div class="column is-1">
            |
          </div>
          <div class="column is-3">{{ $t('general.maximum') }}(MAX)</div>
        </div>
        <div class="columns is-mobile is-centered">
          <div class="column title is-size-4 is-3 box-title has-background-light">
            {{ average | fixed }}
          </div>
          <div class="column title is-size-4 is-3 box-title has-background-light">
            {{ max }}
          </div>
        </div>
        <div class="columns is-mobile is-size-6 font-medium is-centered">
          {{ $t('general.subcategory') }}
        </div>
        <div class="columns is-mobile is-centered">
          <BField>
            <BSelect
              size="is-large"
              placeholder="Subcategorías"
              v-model="currentSubcategory"
              expanded
              @input="onChangeSubcategory"
            >
              <option v-for="subcategorie in subcategories" :value="subcategorie.value" :key="subcategorie.value">{{
                subcategorie.title
              }}</option>
            </BSelect>
          </BField>
        </div>
        <div class="list-columns">
          <template v-for="(col, i) in columns">
            <div :key="i" class="columns is-mobile is-vcentered is-centered ">
              <div class="column has-background-light">
                <p class="font-medium heading has-text-left has-text-grey">{{ col.header }}</p>
                <p class="font-bold has-text-left is-size-5">{{ col.subtitle }}</p>
              </div>
              <div
                class="column is-4 font-subtitle "
                :class="{ 'hover-table-movil': col.value.toFixed(2) > 0 && i > 0 }"
                @click="setOpenMedia(col.value.toFixed(2), col, subcategorie, displayData, item, currentSubcategory)"
              >
                <span>{{ col.value | fixed }}</span>
              </div>
            </div>
          </template>
        </div>
      </section>
    </div>
  </BModal>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
export default {
  props: {
    isActive: {
      required: true,
      type: Boolean,
    },
    item: {
      required: true,
      type: Object,
    },
    subcategorie: {
      required: true,
      type: String,
    },
    displayData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isComponentModalActive: false,
      formProps: {
        email: 'evan@you.com',
        password: 'testing',
      },
      average: 0,
      max: 0,
      currentSubcategory: null,
      subcategories: [],
      temporary: [],
    };
  },
  computed: {
    ...mapGetters('filterGeneral', {
      getGamesPlayedByTeam: 'getGamesPlayedByTeam',
      getResults: 'getResults',
      getSections: 'getSections',
      getPlayingAs: 'getPlayingAs',
      getSelectedGamesIds: 'getSelectedGamesIds',
    }),
    ...mapGetters('teamsGeneral', {
      teamId: 'teamId',
    }),
    ...mapGetters('playersGeneral', {
      playerId: 'playerId',
    }),
    columns() {
      let rows = [];
      if (this.currentSubcategory != null) {
        let currentSubcategory = this.item.items[this.currentSubcategory];
        this.displayData.map(r => {
          let title = r.title,
            header = '',
            subtitle = '';
          if (title.startsWith('MIN')) {
            header = this.$t('table.headers.time_lapse');
            subtitle = title.substring(4);
          } else {
            let index = title.indexOf(' ', title.indexOf(' ') + 1);
            header = title.substr(0, index);
            subtitle = title.substr(index + 1);
          }
          rows.push({ value: currentSubcategory[r.name], header, subtitle });
        });
      }
      return rows;
    },
  },
  watch: {
    item: {
      handler: function(newVal) {
        if (newVal) {
          this.average = newVal.leagueAvg;
          this.max = newVal.totalAccumulated;
          this.subcategories = newVal.items.map((r, i) => {
            return { value: i, title: r.category };
          });
          this.currentSubcategory = this.subcategories.length ? 1 : null;
        }
      },
      inmediate: true,
    },
    subcategorie: {
      handler: function(newVal) {
        if (this.item && newVal) {
          let subcategorie = this.subcategories.find(r => r.title == newVal);
          this.currentSubcategory = subcategorie ? subcategorie.value : null;
        }
      },
      inmediate: true,
    },
  },
  methods: {
    ...mapMutations('mediaModal', ['setModalInitialState', 'setIsModalOpen']),
    onChangeSubcategory(value) {
      let subcategory = this.subcategories.find(s => s.value == value);
      this.$emit('changeSubcategory', subcategory.title);
    },
    setOpenMedia(value, col, currentSub, displayData, item, currentSubcategory) {
      if (value > 0) {
        var timeFilter = '';
        switch (col.subtitle) {
          case 'EQUIPO':
            timeFilter = '';
            break;
          case ' 0 - 15':
            timeFilter = 1;
            break;
          case '16 - 30':
            timeFilter = 2;
            break;
          case '31 - 45':
            timeFilter = 3;
            break;
          case '45 - 60':
            timeFilter = 4;
            break;
          case '61 - 75':
            timeFilter = 5;
            break;
          case '76 - 90':
            timeFilter = 6;
            break;
        }
        var jsonConfig = {
          categoryId: item.items[currentSubcategory].categoryIds,
          mainSectionType: 1,
          gameId: this.getSelectedGamesIds,
          matchResult: this.getResults,
          playData: [],
          advancedFilter: {
            playListTitle: '',
            mainCategoryId: {},
            playingAs: this.getPlayingAs ? [this.getPlayingAs] : [1, 2],
            timeSections: timeFilter == '' ? this.getSections : [timeFilter],
            fieldSections: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
          },
        };
        if (this.teamId) {
          jsonConfig.playerIds = [];
          jsonConfig.teamId = this.teamId;
          jsonConfig.playListType = 3;
        } else {
          jsonConfig.playerIds = [this.playerId];
          jsonConfig.teamId = 0;
          jsonConfig.playListType = 2;
        }
        this.setModalInitialState(jsonConfig);
        this.setIsModalOpen(true);
      }
    },
  },
};
</script>

<style scoped>
#teamModalDetailsModalTable {
  margin-bottom: 20px !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
}
@media screen and (max-width: 350px) {
  #teamModalDetailsModalTable {
    font-size: 12px;
  }
}
.hover-table-movil:hover {
  background: #cbee6b !important;
  opacity: 0.8 !important;
  cursor: pointer !important;
  color: #00a5ff !important;
}
.hover-table-movil {
  text-decoration: underline !important;
}
.box-title {
  border-radius: 10px;
  padding: 6px 0px;
  margin: 0px 12px;
}
.modal-card-body {
  padding: 20px 0px;
}
.list-columns {
  margin-top: 30px;
}
.list-columns .columns {
  border: 1px ridge;
}
.list-columns .column {
  padding-left: 40px;
}
.list-columns .column.is-4 {
  width: 45%;
  padding: 10px;
  font-size: 1, 3rem;
}
.heading {
  margin-bottom: 0px !important;
}
.columns {
  margin-left: 0px;
  margin-right: 0px;
}
.columns.is-gapless {
  margin-bottom: 15px !important;
}
.close-icon {
  float: right;
  color: #000000;
}
.font-bold {
  font-family: Avenir-Demi;
}
.font-medium {
  font-family: Avenir-Demi-Medium;
}
.font-subtitle {
  font-family: Avenir-Demi-Medium;
  font-size: 24px;
}
.modal-card-title {
  width: 100%;
}
</style>
